import { useSelector } from "react-redux";
import Cartitem from "../componenets/Cartitem";
import { useEffect, useState } from "react";
import { toast,ToastContainer } from "react-toastify";
import StripeCheckout from "react-stripe-checkout"
const Carts=()=>{
    const productData=useSelector((state)=>state.bazar.productData)
    const userInfo=useSelector((state)=>state.bazar.userInfo)
    const [totalAmt,settotalAmt]=useState(0);
    const [paynow,setpaynow]=useState(false);
    useEffect(()=>{
        let price=0;
        productData.map((item)=>{
            price+=item.price * item.quantity;
            settotalAmt(price);
        },[productData]);

    })
    const handlebutton=()=>{
        if(userInfo)
        setpaynow(true)
        else
        toast.error("Plz Login First")
    }
    return(<div>
     <img className="w-full h-60 object-cover"
     src="https://images.pexels.com/photos/1435752/pexels-photo-1435752.jpeg?auto=compress" alt="cartImg">
     </img>
     <div className="max-w-screen-xl mx-auto py-20 flex  ">
        <Cartitem settotalAmt={settotalAmt}/>
        <div className="w-1/3 bg-[#fafafa] py-6 px-4 ">
         <div className="flex flex-col gap-6 border-b-[1px] border-b-gray-400 pb-6">
            <h2 className="text-2xl font-medium">cart totals</h2>
            <p className="flex items-center gap-4  text-base">
            Subtotal{" "}
            <span className="font-titleFont font-bold text-lg">
                ${totalAmt}
            </span>
            </p>
         </div>
        <p className="font-titleFont font-semibold flex justify-between mt-6">{" "} Total<span className="text-xl font-bold">${totalAmt}</span></p>
        <div className="flex items-center justify-center">
        <button onClick={handlebutton} className="w-full bg-black px-4 py-2 text-white my-10 ">Payment</button>
        </div>
        {
            paynow && <div className="w-full mt-6 flex items-center justify-center">
            <StripeCheckout stripeKey="pk_test_51PkbOV07JKcHrQqucIRsLHrSpqBXYjFlzaURick2Vi3hQUd3JC4uuhVhJW5Wo5Ls5gHCDGdKDifHcj73ZWflhiT600aO624aiZ" 
            name="Bazar Online Shopping"
            amount={totalAmt*100}
            label="Pay to bazar"
            description={`Your Payment amount is $${totalAmt}`}
           // token={payment}
            email={userInfo.email}
           />
            </div>
        }
       
        </div>
       
     </div>
     <ToastContainer
     position="top-left"
     autoClose={2000}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
     draggable
     pauseOnHover
     theme="dark"
    >
    </ToastContainer>
    </div>)
}
export default Carts;